import styles from "./BannerManager.module.scss";
import { ReactNode, useEffect, useState } from "react";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import { useFetchers } from "react-router-dom";

/**
 * Show the first child banner that exists by hiding all children after the first.
 * Banners that need to load dependencies may render an empty div to hold their place
 * in line.
 * @param seenVals Preference keys indicating if the banner has been seen, used to
 *                 prevent rapid cycling through banners when they change. Banners
 *                 also self-dismiss.
 * @param children Banners to show in priority order
 */
export default function BannerManager({
  dismissKeys,
  children,
}: {
  dismissKeys: UserPreferenceKey[];
  children: ReactNode;
}) {
  const [isSuppressed, setIsSuppressed] = useState(false);

  const fetcher = useFetchers().find((fetcher) =>
    dismissKeys.find(
      (prefKey) =>
        fetcher.formAction?.endsWith(`/actions/user/preferences/${prefKey}`)
    )
  );

  // Don't allow rapid cycling through banners. Suppress banners once there's been a change.
  useEffect(() => {
    if (fetcher) {
      // Do not look at the value. Many but not all are booleans.
      setIsSuppressed(true);
    }
  }, [fetcher]);

  if (isSuppressed) {
    return null;
  }

  return <div className={styles.bannerContainer}>{children}</div>;
}
